import {fetch} from 'whatwg-fetch';
import {AppError} from '@assets/core/AppError';
import queryString from 'query-string';

class MonolitService {
    constructor() {
        this.defaultHeaders = {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
        };
    }

    async getHistory(data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('/filemanager/getFilesLog', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить историю файлов', 500);
        }
    }

    async getFilesIdsForArchiveByDpZajavl(id) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/abitur/online_zajavl_moderation/generateArchiveFilesByDpZajavl/${id}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить список файлов', 500);
        }
    }

    async getFilesIdsForArchiveByVikonZajavl(id) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/abitur/zajavl/generateArchiveFilesByDpZajavl/${id}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить список файлов', 500);
        }
    }

    async getCurrentUpdate() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/update/getCurrentUpdate', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось запустить генерацию архива с обновлением', 500);
        }
    }

    async getUpdateError() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/update/getUpdateError', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сообщить об ошибке для разблокировки обновления', 500);
        }
    }

    async updateVersion() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/update/updateVersionJson', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось создать новую версию', 500);
        }
    }

    async getTaskStatusUpdateFiles() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/editor/lk/update_manual/get_status_files', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                throw response;
            case 403:
                throw new AppError((await response.json()).message);
            case 422:
                throw new AppError((await response.json()).message);
            default:
                throw new AppError('Не удалось получить статус задачи', 500);
        }
    }

    async getTaskStatusIntervalDate() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/editor/lk/update_manual/get_status_files_interval', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                throw response;
            case 403:
                throw new AppError((await response.json()).message);
            case 422:
                throw new AppError((await response.json()).message);
            default:
                throw new AppError('Не удалось получить статус задачи', 500);
        }
    }

    async createTaskForGenerateFilesUpdate() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/editor/lk/update_manual/filesJson', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 403:
                throw new AppError((await response.json()).message);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            case 503:
                throw new AppError((await response.json()).message);
            default:
                throw new AppError('Не удалось создать задачу', 500);
        }
    }

    async createTaskForGenerateFilesIntervalDate(data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('/editor/lk/update_manual/filesIntervalJson', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 403:
                throw new AppError((await response.json()).message);
            case 422:
                throw new AppError(Object.values((await response.json()).errors).join('<br>'));
            case 503:
                throw new AppError((await response.json()).message);
            default:
                throw new AppError('Не удалось создать задачу', 500);
        }
    }

    // списки абитуриентов
    async getCampaignsJson() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/abitur/campaign_switch/getCampaignsJson', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить приемные кампании', 500);
        }
    }

    async printAbiturs(campaignLevelUrObrId, competitionGroupId) {
        const data = {
            campaignLevelUrObrId,
            competitionGroupId,
        };
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('students/printAbiturs', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось распечатать абитуриентов', 500);
        }
    }

    async getFormSettingsCampaignLevelForStudents(campaignLevelId, campaignId) {
        const data = {
            campaign_level_id: campaignLevelId,
            campaign_id: campaignId,
        };
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('/abitur/students/getSettings', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить форму настроек', 500);
        }
    }

    async saveFormSettingsCampaignLevelForStudents(data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data,
        };
        const response = await fetch('/abitur/students/saveSettings', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось сохранить настройки', 500);
        }
    }

    async getSettings() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/settings/getSettingsJson', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить настройки', 500);
        }
    }

    // Работа с документами заявок
    async getZajavlSchemeRemoteLiveList(url) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            url,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить список', 500);
        }
    }

    async getZajavlSchemeRemoteList(url) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            url,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить список', 500);
        }
    }

    async createDocument(documentEdit, applicantId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...documentEdit, applicant_id: applicantId}),
        };
        const response = await fetch(
            '/api/commission/documents',
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось создать документ', 500);
        }
    }

    async updateDocument(id, documentEdit) {
        const options = {
            method: 'PUT',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(documentEdit),
        };
        const response = await fetch(
            `/api/commission/documents/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось обновить документ', 500);
        }
    }

    async getDocument(id) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/documents/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить документ', 500);
        }
    }

    async checkUsedDocumentForZajavl(id, zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/documents/${id}/relations/exclude_entity/3/${zajavlId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ в других объектах',
                    500,
                );
        }
    }

    // Прикрепленные документы
    async attachDocumentToZajavl(documentId, zajavlId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_documents/${documentId}/attach`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось привязать документ к заявлению', 500);
        }
    }

    async unfastenDocumentFromZajavl(documentId, zajavlId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_documents/${documentId}/unfasten`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось открепить документ от заявления', 500);
        }
    }

    async getTagsForZajavlDocuments() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/document_types_tags/zajavl_documents_tags', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить теги документов', 500);
        }
    }

    async getAllSchemesForEditor() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/document_schemes/get_allowed_all_for_editor', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить схемы документов', 500);
        }
    }

    async getApplicantDocuments(applicantId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/documents/get_all_from_applicant/${applicantId}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить документы абитуриента', 500);
        }
    }

    async checkUsedDocumentForAll(id) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/documents/${id}/relations/exclude_entity/0/0`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ где-либо',
                    500,
                );
        }
    }

    async deleteApplicantDocument(id) {
        const options = {
            method: 'DELETE',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/documents/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось удалить документ абитуриента', 500);
        }
    }

    async getSchemesForZajavlDocuments() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/document_schemes/get_allowed_for_attach_to_zajavl', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить схемы документов', 500);
        }
    }

    async getZajavlDocuments(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/applicant/zajavls/${zajavlId}/zajavl_documents`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить документы, прикрепленные к заявлению', 500);
        }
    }

    async getZajavlDocumentsRelations(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/applicant/zajavls/${zajavlId}/zajavl_documents/relations`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить документы, прикрепленные к заявлению', 500);
        }
    }

    async getDocumentsWhichCanAttachToZajavl(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/documents/get_allowed_for_zajavl/${zajavlId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось получить документы, не привязанные к текущему заявлению',
                    500,
                );
        }
    }

    // Льготы
    async updatePrivilege(privilegeEditId, privilegeEdit, zajavlId) {
        const options = {
            method: 'PUT',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(privilegeEdit),
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_privileges/${privilegeEditId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось обновить льготу (особое право)', 500);
        }
    }

    async createPrivilege(privilegeEdit, zajavlId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(privilegeEdit, {arrayFormat: 'bracket'}),
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_privileges`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось сохранить льготу (особое право)', 500);
        }
    }

    async deletePrivilege(id, zajavlId) {
        const options = {
            method: 'DELETE',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_privileges/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось удалить льготу (особое право)', 500);
        }
    }

    async getPrivilege(id, zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_privileges/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить льготу (особое право)', 500);
        }
    }

    async getSchemesForPrivileges() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/document_schemes/get_allowed_for_privileges', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить схемы документов', 500);
        }
    }

    async getDocumentsForPrivileges(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/documents/get_allowed_for_privileges/${zajavlId}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить существующие документы абитуриента', 500);
        }
    }

    async getFisSprBenefits() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/spr/benefits', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить виды льгот', 500);
        }
    }

    async getSprCompetitionsByZajavlId(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/spr/spr_competitions/${zajavlId}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить конкурсы', 500);
        }
    }

    async getCompetitionsByIds(ids) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify({ids}, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('/api/commission/spr/spr_competitions/ids', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить конкурсы', 500);
        }
    }

    async getZajavlPrivileges(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/applicant/zajavls/${zajavlId}/zajavl_privileges`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить льготы (особые права)', 500);
        }
    }

    async checkUsedDocumentForPrivilege(id, privilegeEditId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/documents/${id}/relations/exclude_entity/1/${privilegeEditId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ в других объектах',
                    500,
                );
        }
    }

    // Индивидуальные достижения
    async updateAchievement(achievementEditId, achievementEdit, zajavlId) {
        const options = {
            method: 'PUT',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(achievementEdit),
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_personal_achievements/${achievementEditId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось обновить индивидуальное достижение', 500);
        }
    }

    async createAchievement(achievementEdit, zajavlId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(achievementEdit, {arrayFormat: 'bracket'}),
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_personal_achievements`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось сохранить индивидуальное достижение', 500);
        }
    }

    async deleteAchievement(id, zajavlId) {
        const options = {
            method: 'DELETE',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_personal_achievements/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось удалить индивидуальное достижение', 500);
        }
    }

    async getAchievement(id, zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/zajavls/${zajavlId}/zajavl_personal_achievements/${id}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить индивидуальное достижение', 500);
        }
    }

    async getSchemesForAchievements() {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch('/api/commission/document_schemes/get_allowed_for_personal_achievements', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить схемы документов', 500);
        }
    }

    async getDocumentsForAchievements(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/documents/get_allowed_for_personal_achievements/${zajavlId}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить существующие документы абитуриента', 500);
        }
    }

    async getZajavlAchievements(zajavlId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/applicant/zajavls/${zajavlId}/zajavl_personal_achievements`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить индивидуальные достижения', 500);
        }
    }

    async checkUsedDocumentForAchievement(id, achievementEditId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/documents/${id}/relations/exclude_entity/2/${achievementEditId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ в других объектах',
                    500,
                );
        }
    }

    async getSprAchievementsByCampaignId(campaignId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(`/api/commission/spr/spr_personal_achievements/${campaignId}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить справочник индивидуальных достижений', 500);
        }
    }

    async getAdminStatisticDp(data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data,
        };
        const response = await fetch('/admin/statistic_dp/get', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить статистику', 500);
        }
    }

    async getMessageLog(field, fieldId) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify({field, field_id: fieldId}, {arrayFormat: 'bracket'}),
        };
        const response = await fetch('/abitur/message_log/get', options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить историю сообщений', 500);
        }
    }

    async getFisExportZajavls(filter, pagination, sort, search) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const url = `/api/fis_export/zajavls?
            ${jQuery.param(filter)}&${jQuery.param(pagination)}&${jQuery.param(sort)}&${jQuery.param(search)}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить записи', 500);
        }
    }

    async createRationaleInternalTesting(applicantId, data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const url = `/api/commission/applicant/${applicantId}/rationale_internal_testing`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось создать запись', 500);
        }
    }

    async updateRationaleInternalTesting(id, applicantId, data) {
        const options = {
            method: 'PUT',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const url = `/api/commission/applicant/${applicantId}/rationale_internal_testing/${id}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось обновить запись', 500);
        }
    }

    async getRationaleInternalTesting(resultId, applicantId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const url = `/api/commission/applicant/${applicantId}/rationale_internal_testing/${resultId}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить запись', 500);
        }
    }

    async attachReasonResult(resultId, data) {
        const options = {
            method: 'POST',
            headers: {
                ...this.defaultHeaders,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: queryString.stringify(data, {arrayFormat: 'bracket'}),
        };
        const url = `/api/commission/applicant/results/${resultId}/result_reason/attach_reason_to_result`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось создать запись', 500);
        }
    }

    async deleteReasonResult(id) {
        const options = {
            method: 'DELETE',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/results/${id}/result_reason/unattach_reason_from_result`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось удалить запись', 500);
        }
    }

    async getAllowedForResultReason(resultId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const url = `/api/commission/documents/get_allowed_for_result_reason/${resultId}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить записи', 500);
        }
    }

    async getModerationDocuments(dpApplicantId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const url = `/abitur/online_zajavl_moderation/getDocuments/${dpApplicantId}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError('Не удалось получить записи', 500);
        }
    }

    async checkUsedDocumentForResults(id, applicantResultId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/api/commission/applicant/documents/${id}/relations/exclude_entity/4/${applicantResultId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ в других объектах',
                    500,
                );
        }
    }

    async getApplicantExamResultList(applicantId) {
        const options = {
            method: 'GET',
            headers: {
                ...this.defaultHeaders,
            },
        };
        const response = await fetch(
            `/abitur/applicant_exam/getApplicantExamResultListJson/${applicantId}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 409:
            case 422:
                throw new AppError((await response.json()).errors);
            default:
                throw new AppError(
                    'Не удалось проверить используется ли документ в других объектах',
                    500,
                );
        }
    }
}

export default MonolitService;
